import { useEffect, useRef } from 'react';
import { idsParaAnalizar, pedirAnalisisAPedido } from '../../lib/importaciones';

/**
 * Análisis a pedido (ADR-2026-10-05-analisis-a-pedido): cuando la persona elige un producto importado que
 * espera su análisis, se pide en silencio, una vez por producto, para que esté listo al generar. No hay
 * cartel: la persona ve el "Generando imagen" de siempre, y si todavía no terminó, el backend lo espera.
 */
export function useAnalisisAPedido(productos: Array<{ id: string; analisisPendiente?: boolean }>): void {
  const pedidos = useRef(new Set<string>());
  useEffect(() => {
    const ids = idsParaAnalizar(productos, pedidos.current);
    if (ids.length === 0) return;
    // Se marcan antes de pedir (para no pedirlos dos veces mientras viaja); los que no se aceptaron se desmarcan,
    // así se vuelven a pedir la próxima vez (review Greptile #160).
    for (const id of ids) pedidos.current.add(id);
    void pedirAnalisisAPedido(ids).then((aceptadas) => {
      const ok = new Set(aceptadas);
      for (const id of ids) if (!ok.has(id)) pedidos.current.delete(id);
    });
  }, [productos]);
}
